const unwrapResponse = (response) => response?.data ?? response;

export const createEcobankIdempotencyKey = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  if (globalThis.crypto?.getRandomValues) globalThis.crypto.getRandomValues(bytes);
  else {
    bytes.forEach((_, index) => {
      bytes[index] = Math.floor(Math.random() * 256);
    });
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const createEcobankPaymentApi = (api) => ({
  async read(invoiceId) {
    return unwrapResponse(await api.get(`invoice/${invoiceId}/ecobank-payment/`));
  },

  async sendProfileOtp(invoiceId) {
    return unwrapResponse(await api.post(`invoice/${invoiceId}/ecobank-payment/profile/otp/send/`));
  },

  async resendProfileOtp(invoiceId) {
    return unwrapResponse(await api.post(`invoice/${invoiceId}/ecobank-payment/profile/otp/resend/`));
  },

  async validateProfileOtp(invoiceId, otp) {
    return unwrapResponse(await api.post(`invoice/${invoiceId}/ecobank-payment/profile/otp/validate/`, { otp }));
  },

  async readProfileQr(invoiceId) {
    const payload = unwrapResponse(await api.get(`invoice/${invoiceId}/ecobank-payment/profile/qr-code/`));
    const imageUrl =
      (typeof payload === 'string' && payload) ||
      payload?.qr_code_image_url ||
      payload?.customer_profile?.qr_code_image_url;

    return { imageUrl: imageUrl || null, setupCode: payload?.setup_code || null };
  },

  async activateProfile(invoiceId) {
    return unwrapResponse(await api.post(`invoice/${invoiceId}/ecobank-payment/getprofile/`));
  },

  async completeProfile(invoiceId, token) {
    return unwrapResponse(await api.post(`invoice/${invoiceId}/ecobank-payment/profile/complete/`, { token }));
  },

  async initiatePayment(invoiceId, idempotencyKey) {
    if (!idempotencyKey) throw new Error('IDEMPOTENCY_KEY_REQUIRED');
    return unwrapResponse(
      await api.post(`invoice/${invoiceId}/ecobank-payment/`, undefined, {
        headers: { 'Idempotency-Key': idempotencyKey },
      })
    );
  },

  async authorizePayment(invoiceId, attemptId, otp, idempotencyKey) {
    if (!idempotencyKey) throw new Error('IDEMPOTENCY_KEY_REQUIRED');
    return unwrapResponse(
      await api.post(
        `invoice/${invoiceId}/ecobank-payment/validate/`,
        { attempt_id: attemptId, otp },
        { headers: { 'Idempotency-Key': idempotencyKey } }
      )
    );
  },
});
